import { Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { useHttp } from "../hooks/use-http";
import { uiAction, spotsAction } from "../store/store-actions";
import { AIRPORTS } from "../config";

const AirportParkings = () => {
  const history = useHistory();
  const sendRequest = useHttp();
  const dispatch = useDispatch();
  const curLocGeoCords = useSelector(
    (state) => state.uiStates.curLocGeoCords.lat_lng
  );

  const applyData = (data) => {
    dispatch(spotsAction.setSpots(data.spots));
    dispatch(uiAction.setMoreResultsCount(Number(data.pageCount)));
    history.push("/parkingSpots");
  };

  const getAirportParkingSpots = (airport) => {
    dispatch(uiAction.setSearchedLocGeoCords(airport.lat_lng));
    dispatch(uiAction.setPostCodeSearched(false));
    dispatch(uiAction.setSearchText(airport.opt_val));
    sendRequest(
      {
        url: `getParkingSpots.json`,
        method: "POST",
        data: {
          current_lat_lng: curLocGeoCords,
          searched_lat_lng: airport.lat_lng,
          searchText: airport.opt_val,
          postCodeSearched: false,
        },
      },
      applyData
    );
  };

  return (
    <Fragment>
      <ul>
        {AIRPORTS.map((airport, idx) => (
          <li key={idx}>
            <p
              className="text-sm leading-loose hover:text-primary cursor-pointer"
              onClick={getAirportParkingSpots.bind(null, airport)}
            >
              {airport.name}
            </p>
          </li>
        ))}
      </ul>
    </Fragment>
  );
};

export default AirportParkings;
